(() => {
  if (customElements.get('chicchok-shipping-progress')) return;
  const goal = 5000;
  let latestState = null;
  let latestRevision = -1;
  const cents = value => Number.isSafeInteger(value) && value >= 0;
  const money = value => 'US$' + (value / 100).toFixed(2);
  const normalize = cart => {
    const currency = typeof cart?.currency === 'string' ? cart.currency : cart?.currency?.iso_code;
    const total = cart?.total_price;
    const items = cart?.items;
    if (currency !== 'USD' || !cents(total) || !Array.isArray(items)) return { valid: false, amount: 0 };
    const excluded = item => item.requires_shipping !== true || Number(item.product_id) === 9757488021811 || item.handle === 'shipping-protection';
    if (!items.some(excluded)) return { valid: true, amount: total };
    const netReaders = [
      item => item.line_price,
      item => cents(item.original_line_price) && cents(item.total_discount) ? item.original_line_price - item.total_discount : NaN,
      item => cents(item.original_line_price) && Array.isArray(item.discount_allocations) ? item.original_line_price - item.discount_allocations.reduce((sum, allocation) => sum + allocation.amount, 0) : NaN
    ];
    for (const readNet of netReaders) {
      const nets = items.map(readNet);
      if (nets.every(cents) && nets.reduce((sum, value) => sum + value, 0) === total) {
        return { valid: true, amount: Math.max(0, total - nets.reduce((sum, value, index) => sum + (excluded(items[index]) ? value : 0), 0)) };
      }
    }
    return { valid: false, amount: 0 };
  };
  class ChicchokShippingProgress extends HTMLElement {
    connectedCallback() {
      this.render(latestState || { valid: this.dataset.valid === 'true' && this.dataset.currency === 'USD', amount: Number(this.dataset.merchandise) });
    }
    render(state) {
      const valid = state.valid && cents(state.amount);
      const amount = valid ? state.amount : 0;
      const unlocked = valid && amount >= goal;
      const message = this.querySelector('[data-shipping-message]');
      if (!message) return;
      this.dataset.merchandise = String(amount);
      this.dataset.valid = String(Boolean(valid));
      this.classList.toggle('is-unlocked', unlocked);
      const copy = !valid ? this.dataset.pendingLabel : unlocked ? this.dataset.unlockedLabel : this.dataset.awayTemplate.replace('__AMOUNT__', money(Math.max(0, goal - amount)));
      if (message.textContent !== copy) message.textContent = copy;
      this.querySelector('.cc-shipping__check').hidden = !unlocked;
      const meter = this.querySelector('.cc-shipping__meter');
      meter.hidden = !valid;
      meter.setAttribute('aria-valuenow', String(Math.min(goal, amount)));
      meter.setAttribute('aria-valuetext', copy);
      this.querySelector('.cc-shipping__fill').style.width = Math.min(100, amount / goal * 100) + '%';
      this.querySelector('.cc-shipping__amounts').hidden = !valid;
      this.querySelector('[data-shipping-amount]').textContent = money(amount);
      this.querySelector('[data-shipping-goal]').textContent = unlocked ? this.dataset.reachedLabel : this.dataset.goalLabel;
    }
  }
  customElements.define('chicchok-shipping-progress', ChicchokShippingProgress);
  document.documentElement.addEventListener('cart:updated', event => {
    const detail = event.detail || {};
    const revision = Number(detail.cartRevision);
    if (Number.isFinite(revision) && revision < latestRevision) return;
    if (Number.isFinite(revision)) latestRevision = revision;
    latestState = normalize(detail.cart);
    document.querySelectorAll('chicchok-shipping-progress').forEach(component => component.render(latestState));
  });
})();
